import InstitutionDetailsLayout from '@/features/institution/layouts/details';
import InstitutionRegulatoryInformationForm from '@/features/institution/regulatory-information/components/form';
import { INSTITUTION_DETAILS_TYPE } from '@/features/institution/utils';

const InstitutionOnboardingRegulatoryInformationPage = () => {
  return (
    <InstitutionDetailsLayout detailsKey="regulatoryInformation" detailsType={INSTITUTION_DETAILS_TYPE.ONBOARDING}>
      <InstitutionRegulatoryInformationForm />
    </InstitutionDetailsLayout>
  );
};
InstitutionOnboardingRegulatoryInformationPage.displayName = 'InstitutionOnboardingRegulatoryInformationPage';

export default InstitutionOnboardingRegulatoryInformationPage;
